import type { NotificationsUserQuery } from '@api/dto/gql-helpers.generated';
import { Fragment } from 'react';
import { VList } from 'virtua';

import { Loader } from '@components/loader';

import { MessageItem } from './messageItem';

type MessageListProps = {
  items: NotificationsUserQuery['notification']['messages_user']['items'];
  loading: boolean;
  onLoadMore: (isScreen: boolean) => void;
  hasNextPage: boolean;
  rect: DOMRect;
};

export const MessageList = (props: MessageListProps) => {
  const { items, loading, onLoadMore, hasNextPage, rect } = props;
  return (
    <VList
      className="v-list"
      style={{ height: rect.height }}
      onScrollEnd={() => {
        onLoadMore(hasNextPage && !loading);
      }}
    >
      {items.map((item, index) => (
        <Fragment key={index}>
          <MessageItem
            type={item.payload.type}
            message={item.payload.data.message}
            link={item.payload.data.args?.link}
            viewed={item.viewed}
            date={item.created_at}
          />
        </Fragment>
      ))}

      {loading && <Loader size="small" />}
    </VList>
  );
};
